import axios from 'axios'

const buildUrl = (path: string) => `${process.env.REACT_APP_API_BASE_URL ?? ''}${path}`

export interface PagedResultDto<T> {
  items: T[]
  pageNumber: number
  pageSize: number
  totalItems: number
  totalPages: number
}

export interface AzureAuthConfigDto {
  azureAuthConfigId: string
  tenantId?: string | null
  name: string
  directoryTenantId: string
  clientId: string
  authority?: string | null
  redirectUri?: string | null
  issuer?: string | null
  metadataAddress?: string | null
  contractorDirectoryTenantId?: string | null
  contractorClientId?: string | null
  contractorAuthority?: string | null
  contractorRedirectUri?: string | null
  contractorIssuer?: string | null
  contractorMetadataAddress?: string | null
  enableEmployee: boolean
  enableContractor: boolean
  isActive: boolean
}

export interface AzureAuthConfigUpsertRequest {
  tenantId?: string | null
  name: string
  directoryTenantId: string
  clientId: string
  authority?: string | null
  redirectUri?: string | null
  issuer?: string | null
  metadataAddress?: string | null
  contractorDirectoryTenantId?: string | null
  contractorClientId?: string | null
  contractorAuthority?: string | null
  contractorRedirectUri?: string | null
  contractorIssuer?: string | null
  contractorMetadataAddress?: string | null
  enableEmployee: boolean
  enableContractor: boolean
  isActive: boolean
}

export interface AzureAuthConfigFilter {
  tenantId?: string
  isActive?: boolean
  page?: number
  pageSize?: number
}

export async function searchAzureAuthConfigs(
  filter: AzureAuthConfigFilter,
): Promise<PagedResultDto<AzureAuthConfigDto>> {
  const response = await axios.get<PagedResultDto<AzureAuthConfigDto>>(buildUrl('/api/v1/azure-auth-configs'), {
    params: {
      tenantId: filter.tenantId,
      isActive: filter.isActive,
      page: filter.page ?? 1,
      pageSize: filter.pageSize ?? 20,
    },
  })
  return response.data
}

export async function createAzureAuthConfig(
  payload: AzureAuthConfigUpsertRequest,
): Promise<AzureAuthConfigDto> {
  const response = await axios.post<AzureAuthConfigDto>(buildUrl('/api/v1/azure-auth-configs'), payload)
  return response.data
}

export async function updateAzureAuthConfig(
  id: string,
  payload: AzureAuthConfigUpsertRequest,
): Promise<AzureAuthConfigDto> {
  const response = await axios.post<AzureAuthConfigDto>(buildUrl(`/api/v1/azure-auth-configs/${id}`), payload)
  return response.data
}
